{
  "cycle.entite.plateforme_maintenance_notifications": "Préavis et rappels des maintenances de la plateforme",
  "cycle.entite.plateforme_maintenances": "Maintenances de la plateforme"
}
